var map = {
	"./logo-bocconi.svg": 3823,
	"./logo-caltech.svg": 3824,
	"./logo-cambridge.svg": 3825,
	"./logo-edinburgh.svg": 3826,
	"./logo-oxford.svg": 3827,
	"./logo-texas.svg": 3828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3822;